class PremiumFaq extends HTMLElement {
  connectedCallback() {
    this.classList.add('is-reveal-ready');
    this.items = Array.from(this.querySelectorAll('[data-pfaq-item]'));
    this.allowMultiple = this.dataset.allowMultiple === 'true';

    this.items.forEach((item, index) => {
      item.style.setProperty('--pfaq-index', index);
      item.querySelector('[data-pfaq-trigger]')?.addEventListener('click', this.onTriggerClick);
    });

    this.addEventListener('shopify:block:select', this.onBlockSelect);
    this.setupObserver();
  }

  disconnectedCallback() {
    this.items?.forEach((item) => item.querySelector('[data-pfaq-trigger]')?.removeEventListener('click', this.onTriggerClick));
    this.removeEventListener('shopify:block:select', this.onBlockSelect);
    this.observer?.disconnect();
  }

  onTriggerClick = (event) => {
    const item = event.currentTarget.closest('[data-pfaq-item]');
    if (!item) return;
    this.setItemState(item, !item.classList.contains('is-open'));
  };

  onBlockSelect = (event) => {
    const item = event.target.closest?.('[data-pfaq-item]');
    if (item) this.setItemState(item, true);
  };

  setItemState(item, open) {
    if (open && !this.allowMultiple) {
      this.items.forEach((otherItem) => {
        if (otherItem !== item) this.updateItem(otherItem, false);
      });
    }
    this.updateItem(item, open);
  }

  updateItem(item, open) {
    item.classList.toggle('is-open', open);
    item.querySelector('[data-pfaq-trigger]')?.setAttribute('aria-expanded', open ? 'true' : 'false');
    item.querySelector('[data-pfaq-panel]')?.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  setupObserver() {
    if (!('IntersectionObserver' in window)) {
      this.classList.add('is-revealed');
      return;
    }

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        this.classList.add('is-revealed');
        this.observer.disconnect();
      },
      { rootMargin: '100px 0px', threshold: 0.06 }
    );
    this.observer.observe(this);
  }
}

if (!customElements.get('premium-faq')) {
  customElements.define('premium-faq', PremiumFaq);
}
